import { 
  FETCH_PARTIES_DATA, 
  DELETE_PARTY,
  ACTIVATE_DEACTIVATE_PARTY
} from "../AdminPanel/actions/partiesActionConstants";

import { EDIT_PARTY_REQUEST, SAVE_ASSOCIATED_PARTY } from "../Header/actions/associatedPartiesConstants";

import AppConstants from "../../config/appConstants";

const mappingObject = {};

mappingObject[FETCH_PARTIES_DATA] = {
  url: "/1.0/parties",
  method: AppConstants.httpMethod.GET,
};

mappingObject[DELETE_PARTY] = {
  url: "/1.0/parties",
  method: AppConstants.httpMethod.DELETE,
};

mappingObject[ACTIVATE_DEACTIVATE_PARTY] = {
  url: "/1.0/party/update",
  method: AppConstants.httpMethod.PUT,
};

mappingObject[SAVE_ASSOCIATED_PARTY] = {
  url: "/1.0/party/new",
  method: AppConstants.httpMethod.POST
}

mappingObject[EDIT_PARTY_REQUEST] = {
  url: "/1.0/party/update",
  method: AppConstants.httpMethod.PUT
}

export default mappingObject;
